/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { deletePdf, hideModal, assignParticipantDocument, deleteDocumentError } from '../../actions/actions';
import DeleteDocumentComponent from './delete.document.component';
import { delete_options } from './documents.service';

const REMOVE_DOC_OPERATIONS = {
  removeDocVersion: 'REMOVE',
  removeEntireDoc: 'REMOVE_DOCUMENT'
};

export const mapStateToProps = (store, ownProps) => {
  return {
    consenting: ownProps.props.consenting,
    action: ownProps.props.action,
    isDeleting: store.documents.isDeleting,
    participantJourneyGid: store.subject.participantJourney.gid,
    deleteDocumentError: store.documents.deleteDocumentError
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    close: () => {
      dispatch(deleteDocumentError(null));
      dispatch(hideModal());
    },
    deletePdf: (consenting, reason) => {
      dispatch(deletePdf(consenting, { reason }));
    },
    deleteDocument: (consent, participantJourneyGid, reason, action) => {
      const payload = { reason, documentId: consent.documentId };
      const consentId = consent.consentGid.slice(consent.consentGid.indexOf('|') + 1);
      const removeOperation =
        action === delete_options.document
          ? REMOVE_DOC_OPERATIONS.removeDocVersion
          : REMOVE_DOC_OPERATIONS.removeEntireDoc;
      dispatch(assignParticipantDocument(participantJourneyGid, consentId, removeOperation, payload));
    }
  };
};

const DeleteDocumentContainer = connect(mapStateToProps, mapDispatchToProps)(DeleteDocumentComponent);

export default DeleteDocumentContainer;
